var map = {
	"./AliPay.svg": "4Q5v",
	"./IOSPay.svg": "id5u",
	"./WeiXinPay.svg": "bAHe",
	"./accesDeny.svg": "/Mke",
	"./auditFail.svg": "nlFa",
	"./auditedLogo.svg": "tw+d",
	"./auditingLogo.svg": "A043",
	"./businessUser.svg": "m8lv",
	"./contractRisk.svg": "Sv8v",
	"./criminalRisk.svg": "vmXL",
	"./draftLogo.svg": "cfmZ",
	"./emailSendSuccess.svg": "Vnua",
	"./excelFile.svg": "0GQb",
	"./failBindEmail.svg": "Ps4g",
	"./failSad.svg": "IUE4",
	"./file.svg": "fQ0v",
	"./financeRisk.svg": "nGG1",
	"./knowledgeRisk.svg": "9S49",
	"./login.svg": "j/EP",
	"./managerRisk.svg": "533V",
	"./member.svg": "/LrJ",
	"./noFile.svg": "IQn8",
	"./oops.svg": "9Uso",
	"./oopsNothing.svg": "R/Dl",
	"./pdfFile.svg": "hfQ4",
	"./pptFile.svg": "f7iW",
	"./rejectLogo.svg": "fP99",
	"./setting.svg": "Kttn",
	"./stockRisk.svg": "JVCi",
	"./successSmile.svg": "kQcW",
	"./tareRisk.svg": "XXga",
	"./test-1.svg": "QXJ5",
	"./test-10.svg": "xuNC",
	"./test-11.svg": "F06e",
	"./test-12.svg": "Qo+q",
	"./test-13.svg": "mKxg",
	"./test-14.svg": "ah3P",
	"./test-15.svg": "5mxA",
	"./test-16.svg": "Ph/1",
	"./test-17.svg": "Rvlu",
	"./test-18.svg": "EiYq",
	"./test-19.svg": "7j93",
	"./test-2.svg": "q/gO",
	"./test-20.svg": "8qbl",
	"./test-21.svg": "0oaz",
	"./test-22.svg": "FfeV",
	"./test-23.svg": "gL5g",
	"./test-24.svg": "Vqi9",
	"./test-3.svg": "+Vrz",
	"./test-4.svg": "1x+3",
	"./test-5.svg": "Fj/D",
	"./test-6.svg": "Jdlu",
	"./test-7.svg": "/LIC",
	"./test-8.svg": "7v9S",
	"./test-9.svg": "AHoc",
	"./userCenter.svg": "VEgo",
	"./vedioFile.svg": "rOdt",
	"./voiceFile.svg": "zkYd",
	"./wordFile.svg": "jylC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 48